'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndDocument } from '../../Entities/Ind/IndDocument';
import { IndDocumentCollection } from '../../Collections/Ind/IndDocumentCollection';

export class IndDocumentRepository extends CoreRepository {
  public moveIndDocuments(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveIndDocuments(userId, individualId, payload).then((response) => {
      return response;
    });
  }

  public createIndDocument(indId: number, payload: {}) {
    return this.webAPI.createIndDocument(indId, payload).then((response) => {
      const indDocument = new IndDocument();
      indDocument.hydrate(response);

      return indDocument;
    });
  }
}
